const md5 = require('md5');

function Get(deviceId, deviceName) {
    const secret = 'woshinibaba'
    return md5(deviceName + deviceId + secret)
}

export default {Get}
